import fetchClient from './fetchClient';
import { errorHandler } from './utils';


const config = () => {
    return {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    };
};

export const getProductForecast = async (productId: string, period: 'week' | 'month') => {
    try {
        const res = await fetchClient.get(
            `/forecasting/${productId}?period=${period}`,
            config()
        );
        return res.data;
    } catch (err) {
        errorHandler(err);
        return null;
    }
};
export const getTopProductsForecast = async (period: 'week' | 'month') => {
    try {
        const res = await fetchClient.get(
            `/forecasting/top?period=${period}`,
            config()
        );
        return res.data;
    } catch (error) {
        errorHandler(error);
        return [];
    }
};